module.exports = __webpack_public_path__ + "static/media/profile_image_2_mind_body_fitness.ca4e69e1.webp";